<script setup>
import { ref, computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useUsersGroupsStore } from '@/stores/users-groups'

const translaterStore   = useTranslaterStore()
const usersGroupsStore   = useUsersGroupsStore()

const getTranslate              = computed(() => translaterStore.getTranslate)
const usersGroupsCreateProcess   = computed(() => usersGroupsStore.usersGroupsCreateProcess)
const usersGroupsCreateMsg       = computed(() => usersGroupsStore.usersGroupsCreateMsg)

const UTACreateUsersGroupName = ref('') 
const UTACreateUsersGroupDescr = ref('') 
const formInvalids = ref({}) 
const formErrors = ref([]) 

function submitCreateUsersGroup() {

    formInvalids.value = {}
    formErrors.value = []

    let data = {}

    if(UTACreateUsersGroupName.value) {
        data.name = UTACreateUsersGroupName.value
    } else {
        formInvalids.value.UTACreateUsersGroupName = true
        formErrors.value.push(getTranslate.value.USERS_GROUPS_CREATE_NAME)
    }

    if(UTACreateUsersGroupDescr.value) {
        data.description = UTACreateUsersGroupDescr.value
    }

    if(formErrors.value.length == 0) {
        usersGroupsStore.createUsersGroup(data)
    }
}
</script>

<template>

    <form class="uta-create-users-group" @submit.prevent="submitCreateUsersGroup">

        <div class="mb-4 uta-alert uta-alert--danger" v-if="formErrors.length">
            <span class="material-icons uta-alert__icon">error_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate.EFormFields }}:
                <span class="uta-alert__text-item" v-for="(error, index) in formErrors" :key="error">
                    {{ error }}{{ index !== formErrors.length - 1 ? ', ' : '' }} 
                </span>
            </div>
            <button type="button" class="uta-alert__close" @click="formErrors = [], formInvalids = {}">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div class="mb-4 uta-alert uta-alert--danger" v-if="'success' in usersGroupsCreateMsg && !usersGroupsCreateMsg.success">
            <span class="material-icons uta-alert__icon">error_outline</span>
            <div class="uta-alert__text">
                {{ getTranslate[usersGroupsCreateMsg.text] || usersGroupsCreateMsg.text }}
            </div>
            <button type="button" class="uta-alert__close" @click="usersGroupsStore.setusersGroupsCreateMsg({})">
                <span class="material-icons">close</span>
            </button>
        </div>

        <div class="mb-3 form-group">
            <label for="UTACreateUsersGroupName">{{ getTranslate.USERS_GROUPS_CREATE_NAME }}</label>
            <input 
                type="text" 
                class="form-control" 
                :class="{ 'is-invalid' : formInvalids.UTACreateUsersGroupName }"
                @input="delete formInvalids.UTACreateUsersGroupName"
                id="UTACreateUsersGroupName" 
                v-model="UTACreateUsersGroupName"
            >
        </div>

        <div class="form-group">
            <label for="UTACreateUsersGroupDescr">{{ getTranslate.USERS_GROUPS_CREATE_DESCR }}</label>
            <input 
                type="text" 
                class="form-control" 
                id="UTACreateUsersGroupDescr" 
                v-model="UTACreateUsersGroupDescr"
            >
        </div>

        <div class="uta-btns">
            <button type="submit" class="uta-btn uta-btn--main">
                <template v-if="!usersGroupsCreateProcess">
                    {{ getTranslate.BTN_CREATE }}
                </template>
                <template v-else>
                    <div class="spinner-border uta-header__spinner" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </template>
            </button>
        </div>

    </form>

</template>
